import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { AuthService } from '@nrwl/rx-service-auth';
import { RouterService } from '@nrwl/rx-service-router';
import { AdsBannerComponent } from '../../ads-banner/ads-banner.component';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [
    CommonModule,
    RxIconModule,
    MatTooltipModule,
    RouterModule,
    MatCardModule,
    RxButtonModule,
    MatButtonModule,
    AdsBannerComponent,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  public loginError: string;

  public get currentYear() {
    return new Date().getUTCFullYear();
  }

  constructor(
    private router: Router,
    private routerService: RouterService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.loginError = '';
    this.authService.clearStorage();
  }

  public get title(): string {
    return this.routerService.data.title;
  }

  public backToLogin(): void {
    this.router.navigate(['login']); // root or v19
  }

  public navigateToKnowledgebase() {
    window.open('https://kb.rxphoto.com/portal/en/kb', '_blank');
  }
}
